import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Edition } from 'src/app/modules/editions/models/edition.model';

@Component({
    selector: 'app-edition-selector',
    templateUrl: './edition-selector.component.html',
    styleUrls: ['./edition-selector.component.scss']
})
export class EditionSelectorComponent implements OnInit {

    @Input() editions        : Edition[];
    @Input() selected?       : Edition;
    @Input() defaultSelected?: boolean = false;
    @Input() placeholder?    : string = 'Seleccione una edición...';
    @Input() showClear?      : boolean = false;
    @Input() showFilter?     : boolean = false;

    @Output() selectedChange = new EventEmitter<Edition>();

    constructor() { }

    ngOnInit(): void {

        this.selected = this.defaultSelected ? this.editions[0] : this.selected;
        this.onSelectionChange();

    }

    public onSelectionChange() {

        this.selectedChange.emit(this.selected);

    }

}
